import { FC } from 'react'
import {
  CanadianInternationalPaymentDetails,
  UsAchPaymentDetails,
  IbanPaymentDetails,
  UkPaymentDetails,
  CanadianPaymentDetails,
  UsWirePaymentDetails
} from '@sequencehq/invoice-content'
import { Address } from '@sequencehq/api'
import { DashboardApi20240730 } from '@sequencehq/api/dashboard/v20240730'

type Props = {
  ukAccountDetails?: DashboardApi20240730.SequenceAccount.SortCodeAccountNumber
  iban?: string
  usAchDestination?: DashboardApi20240730.SequenceAccount.UsAchDestination
  usWireDestination?: DashboardApi20240730.SequenceAccount.UsWireDestination
  caBankAccountDestination?: DashboardApi20240730.SequenceAccount.CanadianDestination
  canadianInternationalDestination?: DashboardApi20240730.SequenceAccount.CanadianInternationalDestination
  merchantLegalCompanyName: string
  merchantAddress: Address
  includeBeneficiaryAddressInPaymentDetails: boolean
}
export const BankDetails: FC<Props> = ({
  ukAccountDetails,
  iban,
  usAchDestination,
  usWireDestination,
  caBankAccountDestination,
  canadianInternationalDestination,
  merchantLegalCompanyName,
  merchantAddress,
  includeBeneficiaryAddressInPaymentDetails
}) => {
  return (
    <>
      {ukAccountDetails && (
        <UkPaymentDetails
          ukBankDetails={ukAccountDetails}
          accountName={merchantLegalCompanyName}
          merchantAddress={merchantAddress}
          includeBeneficiaryAddress={includeBeneficiaryAddressInPaymentDetails}
        ></UkPaymentDetails>
      )}
      {iban && (
        <IbanPaymentDetails
          iban={iban}
          accountName={merchantLegalCompanyName}
          merchantAddress={merchantAddress}
          includeBeneficiaryAddress={includeBeneficiaryAddressInPaymentDetails}
        ></IbanPaymentDetails>
      )}

      {usAchDestination && (
        <UsAchPaymentDetails
          achDetails={usAchDestination}
          merchantAddress={merchantAddress}
          includeBeneficiaryAddress={includeBeneficiaryAddressInPaymentDetails}
        ></UsAchPaymentDetails>
      )}
      {usWireDestination && (
        <UsWirePaymentDetails
          wireDetails={usWireDestination}
          merchantAddress={merchantAddress}
          includeBeneficiaryAddress={includeBeneficiaryAddressInPaymentDetails}
        ></UsWirePaymentDetails>
      )}
      {caBankAccountDestination && (
        <>
          <CanadianPaymentDetails
            canadianBankDetails={caBankAccountDestination}
            accountName={merchantLegalCompanyName}
            merchantAddress={merchantAddress}
            includeBeneficiaryAddress={
              includeBeneficiaryAddressInPaymentDetails
            }
          ></CanadianPaymentDetails>
        </>
      )}
      {canadianInternationalDestination && (
        <>
          <CanadianInternationalPaymentDetails
            canadianInternationalDestination={canadianInternationalDestination}
            merchantAddress={merchantAddress}
            includeBeneficiaryAddress={
              includeBeneficiaryAddressInPaymentDetails
            }
          ></CanadianInternationalPaymentDetails>
        </>
      )}
    </>
  )
}
